import { Filesystem, Directory } from '@capacitor/filesystem';

async function ensureDownloadFolderExists() {
  try {
    await Filesystem.stat({
      path: 'Download',
      directory: Directory.External,
    });
    // La carpeta existe
  } catch (e) {
    // No existe, crearla
    await Filesystem.mkdir({
      path: 'Download',
      directory: Directory.External,
      recursive: false,
    });
  }
}

/**
 * Descarga un archivo APK desde una URL al almacenamiento público del dispositivo.
 * Retorna la ruta absoluta donde se guardó.
 */
export async function downloadApk(url, progress): Promise<string> {
  const apkUrl = url;
  const fileName = 'ildes.apk';

  await ensureDownloadFolderExists();

  Filesystem.addListener('progress', progress);

  const downloadResult = await Filesystem.downloadFile({
    url: apkUrl,
    path: `Download/${fileName}`,
    directory: Directory.External,
    progress: true
  });

  if (!downloadResult.path) {
    throw new Error('No se pudo descargar el APK');
  }

  return downloadResult.path;
}